import clsx from "clsx";
import type { MarketplaceConnectionState } from "../../../types/marketplaceAccount";

const styles: Record<MarketplaceConnectionState, { label: string; className: string; icon: string }> = {
  connected: { label: "Connected", icon: "check_circle", className: "tw-bg-emerald-50 tw-text-emerald-700 dark:tw-bg-emerald-950/40 dark:tw-text-emerald-300" },
  reconnect: { label: "Reconnect", icon: "sync_problem", className: "tw-bg-amber-50 tw-text-amber-700 dark:tw-bg-amber-950/40 dark:tw-text-amber-300" },
  disconnected: { label: "Not connected", icon: "remove_circle_outline", className: "tw-bg-slate-100 tw-text-slate-600 dark:tw-bg-slate-800 dark:tw-text-slate-300" },
};

type Props = { state: MarketplaceConnectionState; compact?: boolean };

export function MarketplaceConnectionStatus({ state, compact = false }: Props) {
  const config = styles[state];
  return (
    <span className={clsx("tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-md tw-px-2 tw-py-1 tw-text-xs tw-font-semibold", config.className)}>
      <span className={clsx("material-symbols-outlined", compact ? "tw-text-sm" : "tw-text-base")}>{config.icon}</span>
      {config.label}
    </span>
  );
}
